import { render, staticRenderFns } from "./PDFCanvasV3.vue?vue&type=template&id=57b5895e&scoped=true&"
import script from "./PDFCanvasV3.vue?vue&type=script&lang=js&"
export * from "./PDFCanvasV3.vue?vue&type=script&lang=js&"
import style0 from "./PDFCanvasV3.vue?vue&type=style&index=0&id=57b5895e&scoped=true&lang=css&"
import style1 from "./PDFCanvasV3.vue?vue&type=style&index=1&id=57b5895e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b5895e",
  null
  
)

export default component.exports